import { DataType, StyleType } from '../types/metadata';
import { mapParamToItem } from './conversion-utils';
import { CssDataTypeEnum, GroupType } from './types';
const NUMERIC_STYLE_TYPES = new Set([StyleType.width, StyleType.height, StyleType.fontSize, StyleType.lineHeight, StyleType.letterSpacing, StyleType.borderWidth, StyleType.borderRadius, StyleType.borderTopLeftRadius, StyleType.borderTopRightRadius, StyleType.borderBottomLeftRadius, StyleType.borderBottomRightRadius, StyleType.borderStartStartRadius, StyleType.borderStartEndRadius, StyleType.borderEndStartRadius, StyleType.borderEndEndRadius, StyleType.numberEnum, StyleType.number]);
export const isNumericType = type => NUMERIC_STYLE_TYPES.has(type);
export const mapOOIStylesToManifestStyles = (params, _ref) => {
  let {
    isMobile,
    paramsData = {}
  } = _ref;
  const styles = {};
  for (const [key, {
    metadata,
    key: DMKey
  }] of Object.entries(params)) {
    const param = paramsData[key] || {};
    const {
      displayName
    } = param;
    const styleItem = mapParamToItem({
      metadata,
      params,
      isMobile: isMobile ?? false,
      validate: type => type in StyleType,
      createItem: (type, defaultValue) => {
        const item = {
          cssPropertyType: type,
          ...(typeof isMobile === 'boolean' && {
            defaultValue
          }),
          ...(displayName && {
            displayName
          })
        };
        if (type === StyleType.stringEnum) {
          item.customEnum = {
            cssDataType: CssDataTypeEnum.string,
            options: param.options
          };
        } else if (type === StyleType.numberEnum) {
          var _param$options;
          item.customEnum = {
            cssDataType: CssDataTypeEnum.number,
            options: (_param$options = param.options) == null ? void 0 : _param$options.map(o => ({
              value: String(o.value),
              displayName: o.displayName
            }))
          };
        } else if (isNumericType(type)) {
          item.number = param.options;
        }
        return item;
      }
    });
    if (styleItem) {
      styles[DMKey ?? key] = styleItem;
    }
  }
  return styles;
};
export const mapOOISettingsToManifestData = (params, _ref2) => {
  let {
    isMobile,
    paramsData = {}
  } = _ref2;
  const data = {};
  for (const [key, {
    metadata,
    key: DMKey
  }] of Object.entries(params)) {
    const param = paramsData[key] || {};
    const {
      displayName
    } = param;
    const dataItem = mapParamToItem({
      metadata,
      params,
      isMobile: isMobile ?? false,
      validate: type => type in DataType,
      createItem: (type, defaultValue) => {
        const item = {
          dataType: type,
          ...(typeof isMobile === 'boolean' && {
            defaultValue
          }),
          ...(displayName && {
            displayName
          }),
          ...((metadata == null ? void 0 : metadata.dataItemManifestData) || {})
        };
        if (type === DataType.textEnum) {
          item.textEnum = {
            options: param.options
          };
        } else if (type === DataType.number) {
          item.number = param.options;
        }
        return item;
      }
    });
    if (dataItem) {
      data[DMKey ?? key] = dataItem;
    }
  }
  return data;
};
const mapOOIGroupingToManifestDisplayGroupItem = (type, restOfGrouping) => {
  switch (type) {
    case 'presets':
      return {
        preset: {
          items: restOfGrouping.presets
        }
      };
  }
  return {};
};
const mapOOIGroupingTypeToManifestGroupType = type => {
  switch (type) {
    case 'presets':
      return GroupType.preset;
    default:
      throw new Error(`unsupoorted groupType: ${type}`);
  }
};
export const mapOOIGroupingsToManifestDisplayGroups = params => params.reduce((acc, _ref3) => {
  let {
    id,
    type,
    displayName,
    ...restOfGrouping
  } = _ref3;
  return {
    ...acc,
    [id]: {
      groupType: mapOOIGroupingTypeToManifestGroupType(type),
      displayName,
      ...mapOOIGroupingToManifestDisplayGroupItem(type, restOfGrouping)
    }
  };
}, {});
const mapOOIBreakpointStyleToManifestBreakpointStyle = style => Object.fromEntries(Object.entries(style).map(_ref4 => {
  let [key, value] = _ref4;
  return [key, {
    value
  }];
}));
const mapOOIStyleToManifestStyleOverrides = breakpointStyles => Object.fromEntries(Object.entries(breakpointStyles).map(_ref5 => {
  let [breakpoint, style] = _ref5;
  return [breakpoint, {
    cssCustomProperties: mapOOIBreakpointStyleToManifestBreakpointStyle(style)
  }];
}));
const mapOOIPresetStyleToManifestPresetStyleOverrides = styleOverrides => {
  const {
    default: defaultStyle,
    ...breakpointStyles
  } = styleOverrides;
  return {
    default: {
      cssCustomProperties: mapOOIBreakpointStyleToManifestBreakpointStyle(defaultStyle)
    },
    ...mapOOIStyleToManifestStyleOverrides(breakpointStyles)
  };
};
const mapOOIPresetOptimizedForToManifestOptimizedFor = optimizedFor =>
// @ts-expect-error - TODO: mappers provide mismatched types, remove this once the mappers are fixed (need to use BreakpointEnumBreakpoint from component-protocol - not yet exported)
(optimizedFor == null ? void 0 : optimizedFor.map(breakpoint => breakpoint.valueOf())) ?? [];
export const mapOOIPresetsToManifestPresets = params => params.reduce((acc, _ref6) => {
  let {
    id,
    style,
    optimizedFor,
    ...resetOfPresetConfig
  } = _ref6;
  return {
    ...acc,
    [id]: {
      ...resetOfPresetConfig,
      ...(optimizedFor ? {
        optimizedFor: mapOOIPresetOptimizedForToManifestOptimizedFor(optimizedFor)
      } : {}),
      styleOverrides: mapOOIPresetStyleToManifestPresetStyleOverrides(style)
    }
  };
}, {});
//# sourceMappingURL=manifest-mappers.js.map